export default "__VITE_ASSET__CtDerXyS__"